import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../app/store';
import {
  Button1,
  Container,
  Input1,
  LowerContainer,
  SearchContainer,
  UpperContainer,
} from '../member';
import useTableRoutePath from '../../common/hooks/useTableRoutePath';
import {
  columns,
  initialPushQuery,
} from '../../features/history/staticData/push';
import Table from '../../components/CustomTable';
import { parseQuery } from '../../common/utils/routeUtils';
import { useLocation } from 'react-router-dom';
import CalendarPicker from '../../components/CalendarPicker';
import { getPushLog } from '../../features/history/historySlice';

function Push() {
  const location = useLocation();
  const dispatch = useDispatch();
  const { pushLog } = useSelector(
    (state: RootState) => state.history.pushLogState,
  );
  const {
    query,
    handleChangePage,
    keyword,
    onSubmit,
    setKeyword,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
  } = useTableRoutePath(initialPushQuery);

  useEffect(() => {
    dispatch(getPushLog({ ...query }));
  }, [dispatch, query]);

  return (
    <Container>
      <UpperContainer>
        <SearchContainer onSubmit={onSubmit}>
          <Input1
            type={'text'}
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder={'제목 입력'}
          />
          <Button1 type="submit">검색</Button1>
        </SearchContainer>
        <CalendarPicker
          isOnlyCalender
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      </UpperContainer>
      <LowerContainer>
        <Table
          list={pushLog}
          fetching={false}
          isPaging
          pageState={{
            page: Number(parseQuery(location.search).page || 0),
            rowsPerPage: 10,
          }}
          actions={{
            handleChangePage,
          }}
          columns={columns}
        />
      </LowerContainer>
    </Container>
  );
}

export default Push;
